module.exports = __webpack_public_path__ + "static/playStore-2a86323e8aa0a699436faa3a1ed02dba.png";